import React from "react";
import { Link } from "../../../utils/customLink";
import Image from "../../../components/image";

import Arrowicon from "../../../images/icons/arrow-right-big-icon.inline.svg";
import ArrowiconAlt from "../../../images/icons/right-arrow-dark.inline.svg";

const WhatsItLike = ({ whatItsLike, setAlumniOpenModal }) => {
  const details = whatItsLike;
  const imageLocal = details.whatsitlikeImage;
  const imageFallback = details.whatsitlikeImage?.sourceUrl ?? "";

  return (
    <>
      {details && (
        <div className={""}>
          <h2 className="heading text-left py-5">{details.whatsitlikeLabel}</h2>
          <div className="divide-y width-divider" />

          <Image
            imageClass={"w-full rounded-md my-5"}
            imageAlt={""}
            image={imageLocal}
            sourceUrl={imageFallback}
          />
          <div
            className={
              "dark:gvi-light-gray-text text-black-lighter text-sm tab-content_html"
            }
            dangerouslySetInnerHTML={{ __html: details.whatsitlikeText }}
          />
          <div>
            <h3 className="heading text-left py-5 text-xl !font-light">
              Get a first-hand perspective
            </h3>
            <div className="flex pt-3 flex-col sm:flex-row text-black-lighter">
              <Link
                className="py-1 px-2 flex justify-center items-center h-12 border-current dark:border-gvilightgray border visited:text-black-lighter !text-black-lighter text-base dark:!text-white leading-3 mx-auto mt-2 w-full sm:w-52 sm:m-0 rounded-full hover:border-0 hover:bg-black-lighter hover:!text-white dark:rounded-sm dark:hover:bg-white dark:hover:border-0 dark:hover:!text-black-lighter dark:hover:rounded group"
                to="/come-meet-us/"
              >
                Meet us
                <span className="flex items-center pl-4">
                  <Arrowicon className="fill-black-lighter dark:hidden group-hover:fill-white" />
                  <ArrowiconAlt className="ml-2 right-arrow hidden dark:block dark:stroke-current group-hover:fill-white" />
                </span>
              </Link>

              <button
                className="openModalBtn py-1 px-2 flex justify-center items-center h-12 border-current dark:border-gvilightgray border text-black-lighter text-base dark:text-white leading-3 mx-auto mt-2 w-full sm:w-52 sm:m-0 sm:ml-5  rounded-full dark:rounded-sm dark:hover:bg-white dark:hover:border-0 dark:hover:!text-black-lighter dark:hover:rounded  hover:border-0 hover:bg-black-lighter hover:!text-white group"
                onClick={() => {
                  setAlumniOpenModal(true);
                }}
              >
                Chat to alumni
                <span className="flex items-center pl-4">
                  <Arrowicon className="fill-black-lighter dark:hidden group-hover:fill-white" />
                  <ArrowiconAlt className="ml-2 right-arrow hidden dark:block dark:stroke-current group-hover:fill-white" />
                </span>
              </button>
            </div>
          </div>
          <Link
            className="text-base font-bold underline text-white mt-6  hidden"
            to="#"
          >
            Read about Experiences (New) next
          </Link>
        </div>
      )}
    </>
  );
};

export default WhatsItLike;
